import APICONFIG from '/public/config.json';
export default{
    api(api){
        let url = "";
        if(api){
            url = APICONFIG.API_BASE + APICONFIG[api];
        }else{
            url = APICONFIG.API_BASE;
        }
        return url;
    }
};


export function initialize(store, router, axios, CONFIG, toast_status){

    if(store.state.currentUser){
        axios.get( CONFIG.api('API_USERDATA') ,{
            headers: {
                Authorization: "Bearer " + store.state.currentUserToken
            }
        }).then((data) => {
            store.commit("refreshUserData", data.data);
        }).catch((err) => {
            if(err){
                if (err.response.status === 401) {
                    store.dispatch('logout');
                    router.push('/login');
                }
            }
        });
    }
    
    axios.interceptors.response.use(function (response) {
        return response
    }, function (error) {
        let response = String(error);
        // if(response.includes("Network Error")){
        //     toast_status.fire({ icon: 'error', title: "<i class=\"fas fa-wifi\"></i>", text: "Your are currently offline." });
        // }
        if (error.response.status === 401) {
            if(error.response.data.access_token){
                let token = error.response.data.access_token;
                store.commit("renewToken", token);
                window.axios.defaults.headers.common['Authorization'] = "Bearer " + store.state.currentUserToken;

                error.config.headers.Authorization = window.axios.defaults.headers.common['Authorization'];
                return axios.request(error.config);
            }else{
                store.dispatch('logout');
                router.push('/login');
            }
        }
        return Promise.reject(error)
    })
}